import tw from 'tailwind-styled-components'

const NotifyContainer = tw.div`
md:mx-12
md:my-8
bg-white
md:boxShadow
md:rounded-lg
relative
`
const NotifyMain = tw.main`
flex
flex-col
justify-center
items-center   
py-[83px]
px-2
`
const TitleText = tw.p`
md:text-2xl
text-lg
text-blueTheme
font-bold
mb-4
text-center
`
const SubTitleText = tw.span`
max-w-[431px]
text-center
text-darkGray
mb-[50px]
md:text-base
text-sm
`

const ButtonNewNotify = tw.button`
bg-blueTheme
h-[38px]
text-white
font-semibold
px-[49px]
rounded-lg
md:text-base
text-sm
hover:brightness-95
transition-all
active:scale-95
whitespace-nowrap
`

const TopTitle = tw.p`
px-8
pt-[17px]
text-blueTheme
text-lg
font-semibold
mb-1
`

const FinalTitle = tw.p`
px-8
text-blueTheme
text-xl
font-semibold
mb-2
mt-6
`

const StepText = tw.div`
px-8 
text-sm 
text-darkGray/80
mb-[18px]
`

const FinalSubtitle = tw.div`
px-8 
text-sm 
text-darkGray/80
text-center
`

const SectionSteps = tw.section`
flex 
w-full 
gap-2 
relative
`

const StepsBackLine = tw.div`
absolute 
top-[2px] 
h-px 
bg-borderLine 
w-full 
z-10
`

const StepsLine = tw.div`
h-[5px] 
mb-12 
w-1/5 
z-20
flex 
items-center 
justify-center
`

const StepsCenter = tw.p`
border-[1px] 
w-5
rounded-full 
text-center 
bg-white 
font-bold 
text-sm 
`

const ActionButtons = tw.div`
absolute 
right-0 
pr-8 
pt-[26px] 
flex 
gap-4
`
export const GlassButton = tw.button`
border-[1px]
rounded-lg
border-blueTheme 
text-blueTheme
h-[38px]
justify-center
`
export const BlueButton = tw.button`
border-[1px]
rounded-lg
bg-blueTheme 
text-white 
text-sm
h-[38px]
justify-center
`
export const GreenButton = tw.button`
border-[1px]
rounded-lg
bg-active text-white text-sm
h-[38px]
justify-center
`

const ButtonAction = tw.button`
text-sm
border-[1px]
rounded-lg
h-[38px]
inline-flex
items-center
hover:brightness-95
transition-all
active:scale-[.97]
`

const actionsBack = `
p-4 
border-blueTheme 
text-blueTheme
`

const actionsNext = `
px-[13.5px] 
py-[8.5px] 
text-white 
bg-blueTheme
`
export {
    NotifyContainer,
    NotifyMain,
    TitleText,
    SubTitleText,
    ButtonNewNotify,
    TopTitle,
    StepText,
    SectionSteps,
    StepsBackLine,
    StepsLine,
    StepsCenter,
    ActionButtons,
    ButtonAction,
    FinalTitle,
    FinalSubtitle,
    actionsNext,
    actionsBack,
}
